import {
	IsArray,
	IsBoolean,
	IsDateString,
	IsInt,
	IsNotEmpty,
	IsOptional,
	IsString,
	IsUUID,
	Min,
	ValidateNested,
} from 'class-validator';
import { Type } from 'class-transformer';

export class CreateSlateDto {
	@IsUUID('4')
	@IsNotEmpty()
	event_id: string;

	@IsString()
	@IsNotEmpty()
	name: string;

	@IsString()
	@IsOptional()
	description?: string;

	@IsString()
	@IsOptional()
	group_name?: string;

	@IsDateString()
	opening_date: string;

	@IsDateString()
	closing_date: string;

	@IsBoolean()
	@IsOptional()
	is_event_wide?: boolean;

	@IsArray()
	@IsString({ each: true })
	@IsOptional()
	lobby_ids?: string[];

	@IsInt()
	@Min(0)
	@IsOptional()
	predictions_limit?: number | null;
}

export class UpdateSlateDto {
	@IsUUID('4')
	@IsNotEmpty()
	id: string;

	@IsString()
	@IsOptional()
	name?: string;

	@IsString()
	@IsOptional()
	description?: string;

	@IsInt()
	@Min(0)
	@IsOptional()
	order?: number;

	@IsDateString()
	@IsOptional()
	opening_date?: string;

	@IsDateString()
	@IsOptional()
	closing_date?: string;

	@IsString()
	@IsOptional()
	group_name?: string;

	@IsBoolean()
	@IsOptional()
	is_event_wide?: boolean;

	@IsArray()
	@IsString({ each: true })
	@IsOptional()
	lobby_ids?: string[];

	@IsString()
	@IsOptional()
	slate_title?: string;

	@IsInt()
	@Min(0)
	@IsOptional()
	predictions_limit?: number | null;
}

export class BulkUpdateSlateOrderItemDto {
	@IsUUID('4')
	@IsNotEmpty()
	id: string;

	@IsInt()
	@Min(0)
	order: number;
}

export class BulkUpdateSlatesDto {
	@IsArray()
	@ValidateNested({ each: true })
	@Type(() => BulkUpdateSlateOrderItemDto)
	items: BulkUpdateSlateOrderItemDto[];
}

export class RefreshSlateMatchesDto {
	@IsUUID('4')
	@IsNotEmpty()
	eventId: string;

	@IsUUID('4')
	@IsNotEmpty()
	groupId: string;
}
